import { render } from "./ScannerLayout.vue?vue&type=template&id=05174860"
const script = {}

import "./ScannerLayout.vue?vue&type=style&index=0&id=05174860&lang=css"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__